export const CELL_STATUS = {
  UNVISITED: "UNVISITED",
  START: "START",
  END: "END",
  CHECKING: "CHECKING",
  VISITED: "VISITED",
  WALL: "WALL",
  PATH: "PATH",
};
